<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    :width="width"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="showClose"
    :destroy-on-close="true"
    @closed="handleClosed">
    <slot v-if="visible" />
    <template slot="footer">
      <slot name="footer">
        <el-button
          :loading="loading"
          @click="handleCancel">取 消</el-button>
        <el-button
          v-if="showComfirm"
          :loading="loading"
          type="primary"
          @click="handleSubmit">{{ comfirmText }}</el-button>
      </slot>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'CustomModal',
  props: {
    title: { type: String, default: '' },
    width: { type: String, default: '960px' },
    visible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    showClose: { type: Boolean, default: false },
    comfirmText: { type: String, default: '保 存' },
    showComfirm: { type: Boolean, default: true }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleCancel() {
      this.show = false
    },
    handleSubmit() {
      this.$emit('submit')
    },
    handleClosed() {
      this.$emit('closed')
    }
  }
}
</script>
